import { CognitoUserPool } from 'amazon-cognito-identity-js';

export const poolConfig = {
  UserPoolId: 'us-east-1_CglsU32xQ',
  region: "us-east-1",
  ClientId: '7rq61bsg84giv5vej2u4rmf4qp',
};

export const UserPool = new CognitoUserPool(poolConfig);
